module.exports = __webpack_public_path__ + "img/1b.22e6fa19.jpg";